import { useCallback, useEffect, useState } from 'react';
import api from '../services/api';

const normalizeListPayload = (data) => {
  if (Array.isArray(data)) return data;
  if (data && Array.isArray(data.data)) return data.data;
  return [];
};

export const useDocumentsList = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchDocumentsList = useCallback(async () => {
    setLoading(true);
    try {
      const res = await api.get('/files/user/wallet/list', { skipErrorToast: true });

      if (!res?.ok) {
        setRows([]);
        return;
      }
      const list = normalizeListPayload(res.data);

      const flat = [];

      for (const file of list) {
        const fileMeta = file.file;
        if (!fileMeta?.name) continue;

        const user = file.user ?? {};
        const userId = user.id ?? file.userId;
        const name = user.name ?? file.userName ?? '—';
        const email = user.email ?? file.userEmail ?? '';
        const fileName = fileMeta.name ?? '';
        const documentName = file.name || fileName;

        flat.push({
          id: file.id,
          userId,
          name,
          email,
          documentName,
          fileName,
          url: fileMeta.url,
          downloadUrl: fileMeta.downloadUrl,
          date: file.createdAt,
          status: file.status,
          amount: file.expense?.amount || null,
        });
      }
      setRows(flat);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchDocumentsList();
  }, [fetchDocumentsList]);

  return { data: rows, loading, refetch: fetchDocumentsList };
};
